export default "__VITE_ASSET__CtjAMIoV__"